import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapsiblePanelDarkComponent } from './collapsible-panel-dark.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [CollapsiblePanelDarkComponent],
  imports: [
    CommonModule,
    MatIconModule,
    SharedModule
  ],
  exports: [CollapsiblePanelDarkComponent]
})
export class CollapsiblePanelDarkModule { }
